module.exports = __webpack_public_path__ + "static/media/flag.4fbfdd13.svg";